import { useEffect } from 'react';

// Keep in step with PageTitleable#page_title, which handles the first paint.
export const APP_NAME = 'Grain Portal';
const SEPARATOR = ' | ';

/** Blank prefixes use the product name; `null` requests a bare title. */
export function formatDocumentTitle(name?: string | null, prefix?: string | null): string {
  const trimmedName = name?.trim();
  const leading = prefix === null ? null : prefix?.trim() || APP_NAME;

  if (!trimmedName) return leading || APP_NAME;
  if (!leading) return trimmedName;
  return `${leading}${SEPARATOR}${trimmedName}`;
}

/**
 * Keeps the browser tab in step with the route.
 *
 * The Phlex layout renders the title for first paint, but a section is one
 * Rails page hosting a client-side router — moving between its routes never
 * reloads the document, so without this the tab would keep the title of
 * whichever page happened to be served.
 *
 * Pass the record's own name on detail/edit routes, falling back to the
 * section name while the record loads, so the tab never blanks to the bare
 * product name mid-fetch. Pass `null` as the prefix for a bare title.
 */
export function useDocumentTitle(name?: string | null, prefix?: string | null): void {
  useEffect(() => {
    document.title = formatDocumentTitle(name, prefix);
  }, [name, prefix]);
}
